import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import esLanding from './locales/es/landing.json';
import enLanding from './locales/en/landing.json';
import esTerminos from './locales/es/terminos.json';
import enTerminos from './locales/en/terminos.json';

i18n.use(initReactI18next).init({
  resources: {
    es: { landing: esLanding, terminos: esTerminos },
    en: { landing: enLanding, terminos: enTerminos },
  },
  lng: localStorage.getItem('vox-lang') ||'en',
  fallbackLng: 'es',
  defaultNS: 'landing',
  interpolation: { escapeValue: false },
});

export default i18n;
